import React from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';
import routes from '../../../../../constants/routes';

import useDatasetsQuery from '../../../../../hooks/datasets/useDatasetsQuery';

import { SummaryItem } from './SummaryItem';

export const DatasetSummary = ({
    datasetId,
}: {
    datasetId?: number | null;
}) => {
    const history = useHistory();
    const { data: datasets } = useDatasetsQuery();

    const dataset = datasetId
        ? datasets?.find((d) => d.id === datasetId)
        : undefined;

    return (
        <SummaryItem
            label="Dataset"
            value={
                dataset ? (
                    <DatasetLink
                        onClick={() =>
                            history.push(routes.datasetsView(datasetId))
                        }
                    >
                        {dataset.name}
                    </DatasetLink>
                ) : (
                    'No Dataset'
                )
            }
        />
    );
};

const DatasetLink = styled.span({
    color: aampeTheme.colors.solidA01,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});
